export const GLOBAL_ATTRIBUTES = [
    "accesskey",
    "autocapitalize",
    "autofocus",
    "contenteditable",
    "class",
    "dir",
    "draggable",
    "enterkeyhint",
    "hidden",
    "id",
    "inert",
    "inputmode",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemscope",
    "itemtype",
    "lang",
    "nonce",
    "slot",
    "spellcheck",
    "style",
    "tabindex",
    "title",
    "translate"
];

export const ANCHOR_ATTRIBUTES = [
    "download",
    "href",
    "hrefLang",
    "media",
    "ping",
    "rel",
    "target",
    "type",
    "referrerPolicy"
];

export const AUDIO_ATTRIBUTES = [

];

export const AREA_ATTRIBUTES = [
    "alt",
    "coords",
    "download",
    "href",
    "hrefLang",
    "media",
    "referrerPolicy",
    "rel",
    "shape",
    "target"
];

export const BASE_ATTRIBUTES = [
    "href",
    "target"
];

export const BLOCK_QUOTE_ATTRIBUTES = [
    "cite"
];

export const BUTTON_ATTRIBUTES = [
    "disabled",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "name",
    "type",
    "value"
];

export const CANVAS_ATTRIBUTES = [
    "height",
    "width"
];

export const COL_ATTRIBUTES = [
    "span",
    "width"
];

export const COL_GROUP_ATTRIBUTES = [
    "span"
];

export const DATA_ATTRIBUTES = [
    "value"
];

export const DETAILS_ATTRIBUTES = [
    "open",
    "onToggle"
];

export const DEL_ATTRIBUTES = [
    "cite",
    "dateTime"
];

export const DIALOG_ATTRIBUTES = [
    "onCancel",
    "onClose",
    "open"
];

export const EMBED_ATTRIBUTES = [
    "height",
    "src",
    "type",
    "width"
];

export const FIELDSET_ATTRIBUTES = [
    "disabled",
    "form",
    "name"
];

export const FORM_ATTRIBUTES = [
    "acceptCharset",
    "action",
    "autoComplete",
    "encType",
    "method",
    "name",
    "noValidate",
    "target"
];

export const IFRAME_ATTRIBUTES = [
    "allow",
    "allowFullScreen",
    "allowTransparency",
    "frameBorder",
    "height",
    "loading",
    "marginHeight",
    "marginWidth",
    "name",
    "referrerPolicy",
    "sandbox",
    "scrolling",
    "seamless",
    "src",
    "srcDoc",
    "width"
];

export const IMG_ATTRIBUTES = [
    "alt",
    "crossOrigin",
    "decoding",
    "height",
    "loading",
    "referrerPolicy",
    "sizes",
    "src",
    "srcSet",
    "useMap",
    "width"
];

export const INS_ATTRIBUTES = [
    "cite",
    "dateTime"
];

export const INPUT_ATTRIBUTES = [
    "accept",
    "alt",
    "autoComplete",
    "capture",
    "checked",
    "crossOrigin",
    "disabled",
    "enterKeyHint",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "height",
    "list",
    "max",
    "maxLength",
    "min",
    "minLength",
    "multiple",
    "name",
    "pattern",
    "placeholder",
    "readOnly",
    "required",
    "size",
    "src",
    "step",
    "type",
    "value",
    "width"
];

export const KEYGEN_ATTRIBUTES = [
    "challenge",
    "disabled",
    "form",
    "keyType",
    "keyParams",
    "name"
];

export const LABEL_ATTRIBUTES = [
    "form",
    "htmlFor"
];

export const LI_ATTRIBUTES = [
    "value"
];

export const LINK_ATTRIBUTES = [
    "as",
    "crossOrigin",
    "href",
    "hrefLang",
    "integrity",
    "media",
    "imageSrcSet",
    "imageSizes",
    "referrerPolicy",
    "rel",
    "sizes",
    "type",
    "charSet"
];

export const MAP_ATTRIBUTES = [
    "name"
];

export const MENU_ATTRIBUTES = [
    "type"
];

export const MEDIA_ATTRIBUTES = [
    "autoPlay",
    "controls",
    "controlsList",
    "crossOrigin",
    "loop",
    "mediaGroup",
    "muted",
    "playsInline",
    "preload",
    "src"
];

export const META_ATTRIBUTES = [
    "charSet",
    "content",
    "httpEquiv",
    "name",
    "media"
];

export const METER_ATTRIBUTES = [
    "form",
    "high",
    "low",
    "max",
    "min",
    "optimum",
    "value"
];

export const QUOTE_ATTRIBUTES = [
    "cite"
];

export const OBJECT_ATTRIBUTES = [
    "classID",
    "data",
    "form",
    "height",
    "name",
    "type",
    "useMap",
    "width",
    "wmode"
];

export const OL_ATTRIBUTES = [
    "reversed",
    "start",
    "type" //'1' | 'a' | 'A' | 'i' | 'I' | undefined;
];

export const OPTGROUP_ATTRIBUTES = [
    "disabled",
    "label"
];

export const OPTION_ATTRIBUTES = [
    "disabled",
    "label",
    "selected",
    "value"
];

export const OUTPUT_ATTRIBUTES = [
    "form",
    "htmlFor",
    "name"
];

export const PARAM_ATTRIBUTES = [
    "name",
    "value"
];

export const PROGRESS_ATTRIBUTES = [
    "max",
    "value"
];

export const SLOT_ATTRIBUTES = [
    "name"
];

export const SCRIPT_ATTRIBUTES = [
    "async",
    "charSet",
    "crossOrigin",
    "defer",
    "integrity",
    "noModule",
    "nonce",
    "referrerPolicy",
    "src",
    "type"
];

export const SELECT_ATTRIBUTES = [
    "autoComplete",
    "disabled",
    "form",
    "multiple",
    "name",
    "required",
    "size",
    "value"
];

export const SOURCE_ATTRIBUTES = [
    "height",
    "media",
    "sizes",
    "src",
    "srcSet",
    "type",
    "width"
];

export const STYLE_ATTRIBUTES = [
    "media",
    "nonce",
    "scoped",
    "type"
];

export const TABLE_ATTRIBUTES = [
    "align",
    "bgcolor",
    "border",
    "cellPadding",
    "cellSpacing",
    "frame",
    "rules",
    "summary",
    "width"
];

export const TEXTAREA_ATTRIBUTES = [
    "autoComplete",
    "cols",
    "dirName",
    "disabled",
    "form",
    "maxLength",
    "minLength",
    "name",
    "placeholder",
    "readOnly",
    "required",
    "rows",
    "value",
    "wrap"
];

export const TD_ATTRIBUTES = [
    "align",
    "colSpan",
    "headers",
    "rowSpan",
    "scope",
    "abbr",
    "height",
    "width",
    "valign"
];

export const TH_ATTRIBUTES = [
    "align",
    "colSpan",
    "headers",
    "rowSpan",
    "scope",
    "abbr"
];

export const TIME_ATTRIBUTES = [
    "dateTime"
];

export const TRACK_ATTRIBUTES = [
    "default",
    "kind",
    "label",
    "src",
    "srcLang"
];

export const VIDEO_ATTRIBUTES = [
    "height",
    "playsInline",
    "poster",
    "width",
    "disablePictureInPicture",
    "disableRemotePlayback"
];
